<div class="layout-footer">

    <img src="assets/loghi/{{layoutService.config().colorScheme === 'light' ? 'navbar' : 'navbar'}}.png" alt="Logo" height="20" class="mt-1"/>
    <span class=" ml-3 mt-1 p-2 bg-blue-300 text-white text-sm font-semibold border-round hidden lg:inline">
        v{{ appVersion }}
    </span>
   <!--  by
    <span class="font-medium ml-2">Latitude</span> -->
</div>
